// Copyright © Aptos
// SPDX-License-Identifier: Apache-2.0
export const APTOS_NAMES_ENDPOINT = "https://www.aptosnames.com/api";
